// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/c9ef2df00a22c18bb0f7.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3578828e700374ec4027","124":"0293d1d5515d8470087e","125":"c3620d2ce5c5f0d34aa4"}[chunkId] + ".chunk.js";
};